import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

export const fetchCostingOptions = async (quoteId, productId) => {
	const { data } = await ApiClient.GET(
		`${BASE_URL}/quote/${quoteId}/options?productId=${productId}`,
		'',
		true
	);
	return Array.isArray(data) ? data : data?.payload || [];
};

export const addCostingOption = async (quoteId, requestBody) => {
	const { data } = await ApiClient.POST(`${BASE_URL}/quote/${quoteId}/add-option`, requestBody, '', true);
	return data;
};

export const selectCostingTab = async (quoteId, productId, initialCostingId) => {
	const { data } = await ApiClient.POST(
		`${BASE_URL}/quote/${quoteId}/select-tab?productId=${productId}&initialCostingId=${initialCostingId}`,
		{},
		'',
		true
	);
	return data;
};
